import { useFormikContext } from "formik";
import { stateCityMap, sortData } from "@/utils";
import { ErrorMessage } from "formik";
import { LazyFormikSelect } from "@/components/form/LazyFormikSelect";

const FormikStateSelect = ({ showAsterisk = false, hideLabel = false }) => {
    const { values, setFieldValue } = useFormikContext();

    const stateOptions = sortData(
        Object.keys(stateCityMap).map((state) => ({
            label: state,
            value: state,
        })),
        { mode: "alpha", key: "label" }
    );

    const handleStateChange = (option) => {
        setFieldValue('state', option?.value || '');
    };

    return (
        <>
            <div className="w-full">
                {!hideLabel && <label className="mb-1 form-label">State {showAsterisk && <span className="pl-px text-red-600">*</span>}</label>}
                <LazyFormikSelect
                    name="state"
                    options={stateOptions}
                    placeholder="Select State"
                    onOptionSelect={handleStateChange}
                    preloadedOption={
                        values.state ? { label: values.state, value: values.state } : null
                    }
                />
                <ErrorMessage name="state" component="div" className="text-red-500 text-[11px] mt-1" />
            </div>
        </>
    );
};

export { FormikStateSelect }